import { render, staticRenderFns } from "./DownloadAdd.vue?vue&type=template&id=945bb5f8&scoped=true&"
import script from "./DownloadAdd.vue?vue&type=script&lang=js&"
export * from "./DownloadAdd.vue?vue&type=script&lang=js&"
import style0 from "./DownloadAdd.vue?vue&type=style&index=0&id=945bb5f8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "945bb5f8",
  null
  
)

export default component.exports